import { render, staticRenderFns } from "./welcomeBeforeSession.vue?vue&type=template&id=6c46f96b&scoped=true"
import script from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
export * from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
import style0 from "./welcomeBeforeSession.vue?vue&type=style&index=0&id=6c46f96b&prod&scoped=true&lang=less"
import style1 from "./welcomeBeforeSession.vue?vue&type=style&index=1&id=6c46f96b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c46f96b",
  null
  
)

export default component.exports